// Dark mode: a `data-theme` attribute on <html> that dark.css keys off.
// Dark is the default; once the user flips the switch we remember their choice.
const STORAGE_KEY = 'stew-theme';

const readStored = () => {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === 'dark' || v === 'light' ? v : null;
  } catch (e) {
    return null;
  }
};

const apply = (theme) => {
  document.documentElement.setAttribute('data-theme', theme);
};

export const isDarkMode = () => (readStored() || 'dark') === 'dark';

export const setDarkMode = (dark) => {
  const theme = dark ? 'dark' : 'light';
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch (e) {
    // Storage can be blocked (private mode); the choice then lasts until reload.
  }
  apply(theme);
};

// Call once before the first render so the page doesn't flash light.
export const initTheme = () => {
  apply(isDarkMode() ? 'dark' : 'light');
};
